/*=========================================================================================
  File Name: moduleCountryMutations.js
  Description: Country Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {

SET_TOKENS(state, items) {
      state.Tokens = items;
    } ,
  SET_TOKENSTATUS(state, items) {
      state.TokenStatus = items;
    } ,
  

  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.Tokens.findIndex((p) => p.Id == itemId)
      state.Tokens.splice(ItemIndex, 1)
  },
}
